module.exports = __webpack_public_path__ + "img/gh-36020______.prt.09492e15.jpg";